export const convertDetailNotification = (data) => {
  let converted = {};
  if (!data) return {};

  converted = {
    name: data.name,
    details: convertList(data.details),
  };
  return converted;
};

const convertList = (data) => {
  let converted = [];

  if (!data) return [];

  data.forEach((item) => {
    converted.push({
      title: item.title,
      days: item.value.toString(),
      desc: item.desc,
      value: item.value,
      unit: item.unit,
      condition: item.condition,
    });
  });
  return converted;
};
